// extracted by mini-css-extract-plugin
module.exports = {"fillBlack":"slopesColors_fillBlack__2_dLF","fillGreen":"slopesColors_fillGreen__25hpD","fillRed":"slopesColors_fillRed__25J0-","fillPrimary":"slopesColors_fillPrimary__3XIND"};